const getLinkToAdminHub = (environment: string): string => {
	if (environment === 'PRODUCTION') {
		return 'https://admin.atlassian.com';
	}
	return 'https://admin.stg.atlassian.com';
};

export const linkToAdminHubOrg = (
	environment: string,
	orgId: string | undefined,
	path: string,
): string => {
	if (!orgId) {
		return '';
	}
	return `${getLinkToAdminHub(environment)}/o/${orgId}${path}`;
};
